import templateUrl from "emun.salesrep/market-prompt.htm";
import angular from "angular";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import AutoQuery from "servicestack/auto-query/auto-query";

class controller {
	constructor($scope, options) {
		const $ctrl = this;
		$ctrl.bus = new ServiceBus();
		$ctrl.title = options.title || " Market...";
		$ctrl.marketName = options.marketName;
		$ctrl.year = options.year;

		$ctrl.years = [];
		$ctrl.years.push(moment.utc().add('year', 1).format("YYYY"));
		$ctrl.years.push(moment.utc().format("YYYY"));
		$ctrl.years.push(moment.utc().subtract('year', 1).format("YYYY"));

		$ctrl.loadDays();
	}
	loadDays() {
		let $ctrl = this;
		if ($ctrl.year == undefined) {
			$ctrl.year = "1900";
		}
		$ctrl.bus.send("QueryMarketDates.json?OrderBy=-Year,DayNum&Market=" + $ctrl.marketName + "&year=" + $ctrl.year).then(function (res) {
			$ctrl.marketDates = res.data.results;
			if ($ctrl.marketDates.length) {
				$ctrl.marketDates.map(function (obj, index) {
					obj.id = index;
				});
				$ctrl.showCode = $ctrl.marketDates[0].showCode;
				$ctrl.projectionShowCode = $ctrl.marketDates[0].projectionShowCode;
				$ctrl.year = $ctrl.marketDates[0].year;
				$ctrl.projectionDollar = $ctrl.marketDates[0].projectionDollar;
				$ctrl.marketDates.forEach(function (m) {
					m.showDate = moment.utc(m.showDate);
				});
			}
		});
	}
	submit() {
		let $ctrl = this;
		$ctrl.marketDates.forEach(function (obj) {
			obj.id = undefined;
			obj.year = $ctrl.year;
			obj.projectionDollar = $ctrl.projectionDollar;
			obj.projectionShowCode = $ctrl.projectionShowCode;
			obj.showCode = $ctrl.showCode;
			obj.showDate = obj.showDate.format("DD/MM/YYYY");
		});
		$ctrl.bus.send("SaveMarketDates.json", {
			Market: $ctrl.marketName,
			Year: $ctrl.year,
			items: $ctrl.marketDates
		}).then(function (res) {
			$ctrl.$dismiss();
		});
	}
	deleteMarketDate(market) {
		let $ctrl = this;
		$ctrl.marketDates = $ctrl.marketDates.filter(function (obj) {
			return obj.id !== market.id;
		});
	}
	addMarketDate() {
		let $ctrl = this;
		$ctrl.marketDates.push({
			dayNum: $ctrl.marketDates.length ? $ctrl.marketDates[$ctrl.marketDates.length - 1].dayNum + 1 : 1,
			market: $ctrl.marketName,
			year: $ctrl.year,
			showCode: $ctrl.showCode,
			projectionShowCode: $ctrl.projectionShowCode,
			projectionDollar: $ctrl.projectionDollar,
			showDate: moment.utc(),
			id: $ctrl.marketDates.length + 1
		});
	}

}

export default {
	open(options) {
		return modals.open(
			Object.assign(
				{
					templateUrl,
					resolve: {
						options: () => options
					},
					bindToController: true,
					controller,
					controllerAs: "$ctrl",
					size: 'lg'
				},
				(options || {}).modal
			)
		).result;
	}
};
